import SlimSelect from 'slim-select';

export default class FilterDropdown {

    async init(): Promise<void> {
        this.filterDropdown();
        jQuery(document).on('ajaxComplete', () => this.filterDropdown());
    }
    
    async filterDropdown(): Promise<void> {
        const filterDropdowns: NodeListOf<HTMLElement> | null = document.querySelectorAll('.wcapf-dropdown-nav');

        if (!filterDropdowns) return;

        filterDropdowns.forEach((filterDropdown) => {
            const filterDropdownSelect: HTMLSelectElement | null = filterDropdown.querySelector('select');

            if (!filterDropdownSelect) return;

            new SlimSelect({
                select: filterDropdownSelect,
                settings: {
                    showSearch: false,
                    searchHighlight: true,
                    openPosition: 'down',
                    placeholderText: 'Wybierz wartość',
                },
                events: {
                    afterChange: (info) => {
                        filterDropdownSelect.dispatchEvent(new CustomEvent('change', { bubbles: true }))
                    }
                }
            });
        })

    }
    
}
